<!-- 组装出仓弹窗 -->
<template>
  <div class="warehouseOut" v-loading="loading">
    <div class="warehouseOut-main">
      <div class="div-table-row table-title">
        <div class="div-table-cell" style="width: 15%">配件名称</div>
        <div class="div-table-cell" style="width: 15%">配件编码</div>
        <div class="div-table-cell" style="width: 10%">出仓数</div>
        <div class="div-table-cell flex" style="width: 60%">
          <div class="border-right cell-item" style="width: 30%">仓库</div>
          <div class="border-right cell-item" style="width: 30%">仓位</div>
          <div class="border-right cell-item" style="width: 20%">数量</div>
          <div class="cell-item" style="width: 20%"></div>
        </div>
      </div>
      <div class="table-main">
        <div
          class="div-table-row"
          v-for="(item, index) in dataList"
          :key="item.EntpTempGoodsId"
        >
          <div class="div-table-cell" style="width: 15%">
            {{ item.GoodName }}
          </div>
          <div class="div-table-cell" style="width: 15%">
            {{ item.APCode }}
          </div>
          <div class="div-table-cell" style="width: 10%">
            {{ OpCount > 0 ? item.Count * OpCount : item.Count }}
          </div>
          <div class="div-table-cell" style="width: 60%">
            <div
              class="cell-line"
              v-for="(warehouse, i) in item.GoodsLocationList"
              :key="i.key"
            >
              <div class="border-right cell-item" style="width: 30%">
                {{ WarehouseName }}
              </div>
              <div class="border-right cell-item" style="width: 30%">
                <el-select
                  v-model="warehouse.ShelfSpaceId"
                  filterable
                  clearable
                  reserve-keyword
                  @change="positionChange($event, index, i)"
                  size="small"
                  @visible-change="
                    positionVisibleChange(
                      $event,
                      item.EntpTempGoodsId,
                      warehouse
                    )
                  "
                >
                  <el-option
                    v-for="optionItem in warehouse.positionList"
                    :label="optionItem.ShelfSpaceCode"
                    :value="optionItem.ShelfSpaceId"
                    v-bind:key="optionItem.index"
                  >
                    <span style="display: inline-block; width: 150px">{{
                      optionItem.ShelfSpaceCode
                    }}</span>
                    <span>库存:{{ optionItem.Count }}</span>
                  </el-option>
                </el-select>
              </div>
              <div class="border-right cell-item" style="width: 20%">
                <el-input
                  size="small"
                  type="number"
                  v-model="warehouse.Count"
                  @blur="checkCount(warehouse.Count, warehouse.CountMax)"
                  :max="warehouse.CountMax"
                >
                </el-input>
              </div>
              <div
                class="cell-item ops-ctn"
                style="width: 20%; height: 28px; margin-top: 7px"
              >
                <el-button
                  size="mini"
                  icon="el-icon-minus"
                  @click="delItem(index, i)"
                ></el-button>
              </div>
            </div>
          </div>
          <el-button
            size="mini"
            icon="el-icon-plus"
            class="add-btn"
            @click="addItem(index)"
          ></el-button>
        </div>
      </div>
    </div>
    <div class="dialog-footer">
      <el-button size="small" @click="cancel">取消</el-button>
      <el-button class="btn-primary" size="small" @click="submitData"
        >提交组包</el-button
      >
    </div>
    <!--    快速存放商品    -->
    <!-- <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="快速存放商品"
      :visible.sync="storeVisible"
      width="1000px"
      append-to-body
      :before-close="closeStoreDialog"
    >
      <div v-if="storeVisible">
        <storeInventoryGoods
          :autopartItem="enterprisePartData"
          @closeDialog="closeStoreDialog"
        ></storeInventoryGoods>
      </div>
    </el-dialog> -->
     <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="存放组装套包"
      :visible.sync="storeVisible"
      width="1000px"
      append-to-body
      :before-close="closeStoreDialog"
    >
      <div v-if="storeVisible">
        <storeSetOrderGoods
          :goodsList="enterprisePartData"
          :setOrderId="formData.SetOrderId"
          @closeDialog="closeStoreDialog"
        ></storeSetOrderGoods>
      </div>
    </el-dialog>   
  </div>
</template>
<script>
import storeInventoryGoods from "@/components/business/goods/storeInventoryGoods.vue";
import storeSetOrderGoods from "@/components/business/goods/storeSetOrderGoods.vue"; 
export default {
  name: "",
  props: ["APList", "SetId", "OpCount", "SetOrderId", "SId", "WarehouseName"],
  components: { 
    // storeInventoryGoods,
    storeSetOrderGoods },
  data() {
    let userMsg = this.$util.getLocalStorage("userMsg");
    return {
      loading: false,
      storeVisible: false,
      formData: {
        SetId: this.SetId,
        UserId: userMsg.EmployeeId,
        EntpId: userMsg.EntpId,
        OpCount: this.OpCount,
        SetOrderId: this.SetOrderId,
        DetailList: [
          {
            EntpTempGoodsId: "",
            GoodsLocationList: [
              {
                ShelfSpaceId: "",
                Count: "",
              },
            ],
          },
        ],
      },
      dataList: [],
      PositionList: [],
      enterprisePartData: {},
    };
  },
  mounted() {
    let _data = {
      WarehouseName: "",
      ShelfSpaceCode: "",
      ShelfSpaceId: "",
      Count: "",
      CountMax: 999,
      positionList: [],
    };

    let _APList = [];
    for (let i = 0; i < this.APList.length; i++) {
      _data.Count =
        this.OpCount > 0
          ? this.APList[i].Count * this.OpCount
          : this.APList[i].Count;
      // 多个层级影响，不能直接赋值，需要用set才能触发响应
      this.$set(this.APList[i], "GoodsLocationList", [{ ..._data }]);
      _APList.push(this.APList[i]);
    }
    this.dataList = _APList;
  },
  methods: {
    checkCount(count, max) {
      if (count > max) {
        this.$util.warningMsg("数量不得大于库存数量");
      }
    },
    cancel() {
      this.$emit("closeDialog");
    },
    submitData() {
      let that = this;
      let _data = that.dataList;
      for (let i = 0; i < _data.length; i++) {
        let PV = Number(_data[i].Count);
        let EV = 0;
        for (let j = 0; j < _data[i].GoodsLocationList.length; j++) {
          if (!_data[i].GoodsLocationList[j].ShelfSpaceId) {
            that.$util.warningMsg("请选择仓位");
            return;
          }
          if (
            _data[i].GoodsLocationList[j].Count >
            _data[i].GoodsLocationList[j].CountMax
          ) {
            that.$util.warningMsg("数量不得大于库存数量");
            return;
          }
          EV += Number(_data[i].GoodsLocationList[j].Count);
        }
        if (this.SetId) {
          if (PV * that.OpCount != EV) {
            that.$util.warningMsg("出库数量与列表填写不相等");
            return;
          }
        } else {
          if (PV != EV) {
            that.$util.warningMsg("出库数量与列表填写不相等");
            return;
          }
        }
      }

      that.formData.DetailList = that.dataList;
      that.loading= true;

      that.$util
        .axiosPost({
          url: "/api/EntpGoods/PackEnterpriseSetOrder",
          data: that.formData,
          hideLoading: true
        })
        .then((res) => {
          if (res.errcode == 0) {
              that
                .$confirm(
                  "组装成功！但并未存放，是否去存放货物？",
                  "温馨提示",
                  {
                    confirmButtonText: "存放货物",
                    cancelButtonText: "取消",
                    type: "success",
                    center: true,
                  }
                )
                .then(() => {
                  that.enterprisePartData = res.data;
                  that.showStoreDialog();
                })
                .catch(() => {
                  that.loading= true;
                  that.$util.successMsg(res.errmsg);
                  that.$store.commit("updateNeedRefresh", true);
                  that.$emit("closeDialog", true);
                });
          } else that.$util.errorMsg(res.errmsg);
          that.loading=false;
        }).catch(() => {that.loading=false;});
    },
    positionChange(value, index, i) {
      let flag = 0;
      let _data = { ...this.dataList[index] };
      let target = _data.GoodsLocationList[i].positionList
        ? _data.GoodsLocationList[i].positionList
        : [];
      for (let j = 0; j < _data.GoodsLocationList.length; j++) {
        if (_data.GoodsLocationList[j].ShelfSpaceId == value) {
          flag += 1;
          if (flag >= 2) {
            _data.GoodsLocationList[j].ShelfSpaceId = "";
            this.$util.warningMsg("不能选相同仓位");
            return;
          }
        }
      }
      for (let n = 0; n < target.length; n++) {
        if (target[n].ShelfSpaceId == value) {
          _data.GoodsLocationList[i].CountMax = target[n].Count;
        }
      }
      this.$set(this.dataList, index, _data);
    },
    delItem(index, i) {
      let _data = { ...this.dataList[index] };
      if (_data.GoodsLocationList.length != 1) {
        _data.GoodsLocationList.splice(i, 1);
      }
      this.$set(this.dataList, index, _data);
    },
    addItem(index) {
      let _target = this.dataList[index].GoodsLocationList;
      for (let i = 0; i < _target.length; i++) {
        if (!_target[i].ShelfSpaceId) {
          this.$util.warningMsg("请选择仓位");
          return;
        }
        if (!_target[i].Count || !_target[i].Count < 0) {
          this.$util.warningMsg("请填写正确的数量");
          return;
        }
      }
      let _data = { ...this.dataList[index] };
      _data.GoodsLocationList.push({
        WarehouseName: "",
        ShelfSpaceCode: "",
        ShelfSpaceId: "",
        Count: this.dataList[index].Count,
        positionList: [],
      });
      this.$set(this.dataList, index, _data);
    },
    showStoreDialog() {
      this.storeVisible = true;
    },
    closeStoreDialog(refresh=false) {
      this.storeVisible = false;
      // 关闭弹窗
      // setTimeout(() => {
      //   this.$store.commit("updateNeedRefresh", true);
      //   window.history.go(-1);
      // }, 2000);
      this.$emit("closeDialog", true);
    },
    searchPosition(goodsId) {
      let that = this;
      return that.$util
        .axiosGet({
          url: "/api/EntpGoods/GetEntpSetGoodsPositionDatas",
          data: {
            WarehouseId: that.SId,
            GoodsId: goodsId,
            EntpId: that.formData.EntpId,
          },
          hideLoading: true,
        })
        .then((res) => {
          that.loading = false;
          if (res.data) {
            that.PositionList = res.data.LocationList;
          } else {
            that.$util.warningMsg("该仓库暂无仓位");
          }
        })
        .catch((error) => {
          that.loading = false;
        });
    },
    positionVisibleChange(val, goodsId, warehouse) {
      if (!val || !goodsId) return;
      let that = this;
      if (!(warehouse.positionList && warehouse.positionList.length > 0)) {
        that.searchPosition(goodsId).then(() => {
          that.$set(warehouse, "positionList", [...that.PositionList]);
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.add-btn {
  position: absolute;
  right: 10px;
  bottom: 6px;
}
.ops-ctn {
  text-align: left !important;
}
.dialog-footer {
  text-align: right;
  margin-top: 20px;
}
.warehouseOut-main {
  padding-top: 20px;
}
.table-title {
  .cell-item {
    width: 33.33%;
  }
  .div-table-cell {
    text-align: center;
    height: 30px;
    line-height: 30px;
  }
}
.div-table-row {
  position: relative;
  overflow: visible;
}
.table-main {
  .div-table-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .cell-line {
    display: flex;
    width: 100%;
  }
  .cell-item {
    padding: 0 10px;
    width: 33%;
    width: inherit;
    text-align: center;
    height: 40px;
    line-height: 40px;
  }
}
</style>
